<script lang="ts">
    import { modalManagerToken } from "@/tokens";
    import LoadMoreButton from "@apps/iloom_customization/components/LoadMoreButton.svelte";
    import DesignFeedMasonry from "@apps/iloom_customization/design_feed/components/DesignFeedMasonry.svelte";
    import DesignFeedModal from "@apps/iloom_customization/design_feed/components/DesignFeedModal/DesignFeedModal.svelte";
    import DesignFeedTabs from "@apps/iloom_customization/design_feed/components/DesignFeedTabs.svelte";
    import { MediaListQuery } from "@apps/iloom_customization/design_feed/queries/MediaListQuery";
    import { DesignFeedService } from "@apps/iloom_customization/design_feed/services/DesignFeedService";
    import { ProductQuery } from "@apps/iloom_customization/modules/products/queries/ProductQuery";
    import { ProductService } from "@apps/iloom_customization/modules/products/services/ProductService";
    import { WishlistService } from "@apps/iloom_customization/wishlist/services/WishlistService";
    import { WishlistProductStatusesQuery } from "@apps/wishlist/queries/WishlistProductStatusesQuery";
    import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
    import { CartQuery } from "@modules/cart/queries/CartQuery";
    import { CartService } from "@modules/cart/services/CartService";
    import { lastValueFrom } from "rxjs";
    import { onMount } from "svelte";
    import { container } from "tsyringe";

    import Portal from "@components/Portal/Portal.svelte";
    import TabsManager from "@components/Tabs/TabsManager";

    export let cartQuery: CartQuery;
    export let cartService: CartService;
    export let designFeedService: DesignFeedService;
    export let mediaListQuery: MediaListQuery;
    export let productQuery: ProductQuery;
    export let productService: ProductService;
    export let tabsManager: TabsManager;
    export let tags: { name: string; value: string }[];
    export let wishlistService: WishlistService;
    export let wishlistsService: WishlistsService;
    export let wishlistProductStatusesQuery: WishlistProductStatusesQuery;

    const modalManager = container.resolve(modalManagerToken);

    const openedTab$ = tabsManager.openedTab$;

    const mediaList$ = mediaListQuery.mediaList$;
    const meta$ = mediaListQuery.meta$;
    const loadMoreStatus$ = mediaListQuery.loadMoreStatus$;

    const getMediaList = (offset = 0) => {
        if ($openedTab$) {
            const params = {
                offset,
                tags: [$openedTab$],
                limit: $meta$.limit,
            };
            lastValueFrom(designFeedService.getMediaList(params));
        }
    };

    onMount(() => {
        tabsManager.openTab(tags[0]?.value);

        const changeTabSubscription = openedTab$.subscribe(() => {
            getMediaList();
        });

        return () => changeTabSubscription.unsubscribe();
    });
</script>

<div class="gw-df-product-page">
    {#if $mediaList$.length > 0}
        <h2 class="gw-df-product-page__title">設計摘要</h2>
        <DesignFeedTabs tabs={tags} {tabsManager} />
    {/if}
    <DesignFeedMasonry {designFeedService} {mediaListQuery} {modalManager} />
    <div class="gw-df-product-page__space" />
    <LoadMoreButton
        loadMore={getMediaList}
        loadMoreStatus={$loadMoreStatus$}
        meta={$meta$}
    />
</div>

<Portal
    Component={DesignFeedModal}
    componentProps={{
        cartQuery,
        cartService,
        designFeedService,
        mediaListQuery,
        modalManager,
        productQuery,
        productService,
        wishlistService,
        wishlistsService,
        wishlistProductStatusesQuery,
    }}
    selector="body"
/>

<style lang="postcss">
    .gw-df-product-page {
        --gw-tab-font-family: "Montserrat";

        padding: 100px 0;
        background-color: #f7f7f7;
        box-shadow: 0 0 0 100vmax #f7f7f7;
        clip-path: inset(0 -100vmax);

        :global(.gw-tab .gw-tab-btn) {
            --gw-tab-rounded-bg-color: #fff;
        }
        &__title {
            font-family: "Noto Sans TC";
            font-weight: 500;
            font-size: 30px;
            text-align: center;
            margin: 0 0 20px;
        }
        &__space {
            margin-bottom: 40px;
        }
        @media all and (max-width: 600px) {
            padding: 60px 0 24px;
        }
    }
</style>
